<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import AuthenticatedRequireEmailVerification from '@/pages/Authenticate/AuthenticatedRequireEmailVerification.vue'
import { useCompleteLogin } from './complete-login'

export default defineComponent({

  name: 'AuthenticatedPage',

  components: { AuthenticatedRequireEmailVerification },

  setup() {

    const { completeLogin, emailVerificationRequired, userIdentity, tenant } = useCompleteLogin()

    const loading = ref(true)

    onMounted(async () => {
      await completeLogin()
      if (emailVerificationRequired.value) {
        loading.value = false
      }
    })

    return {
      loading,
      userIdentity,
      tenant,
    }

  },

})

</script>

<template>
  <div>
    <div
      v-if="loading"
      class="authenticated"
    >
      <sm-loader />
    </div>
    <div v-if="userIdentity && userIdentity.emailVerificationRequired">
      <AuthenticatedRequireEmailVerification :email="userIdentity.email" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.authenticated {
  @apply flex justify-center items-center min-h-screen;
}
</style>
